import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AdminTableComponent from 'routes/Admin/components/CommonComponents/AdminTableComponent'
import {
  MODAL_ADMIN_EDIT_PLAYER,
  MODAL_ADMIN_CREATE_PLAYER,
  MODAL_ADMIN_DELETE_PLAYER,
  MODAL_ADMIN_REORDER_PLAYER
} from 'redux/modules/modals'
const defaultColumnData = [
  { id: 'name', numeric: false, disablePadding: true, label: 'Nom' },
  { id: 'reduc', numeric: true, disablePadding: false, label: 'Réduction (%)' },
  {
    id: 'order',
    numeric: true,
    disablePadding: false,
    label: `Ordre d'affichage`
  }
]
export default class AdminPlayersComponent extends Component {
  static propTypes = {
    players: PropTypes.array.isRequired,
    showModal: PropTypes.func.isRequired
  }
  handleAddPlayerClick = () => {
    this.props.showModal(MODAL_ADMIN_CREATE_PLAYER)
  }
  handleEditPlayerClick = player => {
    this.props.showModal(MODAL_ADMIN_EDIT_PLAYER, player)
  }
  handleDeletePlayerClick = player => {
    this.props.showModal(MODAL_ADMIN_DELETE_PLAYER, player)
  }
  handleReorderClick = () => {
    this.props.showModal(MODAL_ADMIN_REORDER_PLAYER, this.props.players)
  }

  render() {
    const { players } = this.props
    return (
      <div style={{ paddingTop: 24 }}>
        <AdminTableComponent
          title="Type de joueurs"
          selectable
          list={players}
          orderBy={'order'}
          columnData={defaultColumnData}
          addButtonAction={this.handleAddPlayerClick}
          editButtonAction={this.handleEditPlayerClick}
          reOrderAction={players.length < 2 ? null : this.handleReorderClick}
          deleteButtonAction={
            players.length === 1 ? null : this.handleDeletePlayerClick
          }
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/Admin/Players/components/PlayersComponent.js